/**
 * Status einer Gruppenbuchung
 */
export enum GroupBookingStatus {
   /**
    * Buchungsanfrage vom Kunden erhalten. Terminfindung und Angebot sind noch nicht abgeschlossen.
    */
   requested = "requested",

   /**
    * Angebot an Kunden vorbereitet, Kunde muss Angebot bestätigen.
    */
   offerToCustomer = "offerToCustomer",

   /**
    * Angebot ist vom Kunden bestätigt.
    */
   offerAccepted = "offerAccepted",

   /**
    * Buchung ist vollständig, Jugendfarm hat den Termin angenommen.
    */
   booked = "booked",

   /**
    * Event durchgeführt, Rechnung kann gestellt werden.
    */
   readyForPayment = "readyForPayment",

   /**
    * Rechnung wurde exportiert. Jetzt ist nichts mehr zu tun.
    */
   paymentExported = "paymentExported",

   /**
    * Event wurde von Kunde storniert. Mitarbeiter:in muss Stornierung bestaetigen.
    */
   cancellationPending = "cancellationPending",

   /**
    * Event ist storniert. Rechnung mit Stornierungsgebuehren kann erstellt werden.
    */
   canceled = "canceled",

   /**
    * Event wurde storniert und Stornierungsgebuehr wurde exportiert.
    */
   cancellationFeeExported = "cancellationFeeExported"
}